import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react';

import { PopoverContent, type PopoverContentProps } from '../../Popover';

type FilterChipContentProps = ComponentPropsWithoutRef<typeof PopoverContent>;

export const FilterChipContent = forwardRef<
  ElementRef<typeof PopoverContent>,
  FilterChipContentProps
>(({ align = 'start', ...props }, ref) => {
  return <PopoverContent ref={ref} align={align} {...props} />;
});

FilterChipContent.displayName = 'FilterChipContent';

export type { PopoverContentProps as FilterChipContentProps };
